import { useDispatch } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { searchRmas } from '../../redux/rmas/redux';

export const useSearchRmasAction = (): typeof searchRmas => {
  const dispatch = useDispatch();

  return bindActionCreators(searchRmas, dispatch);
};
